export default __webpack_public_path__ + "static/media/payments.e9e5d120.svg";